(function () {
  var MOBILE_QUERY = '(max-width: 769px)';
  var SECTION_SELECTOR = '#sydney-marathon-early-bird-offer';

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function closeCallout(callout) {
    callout.classList.remove('is-open');
    callout.setAttribute('aria-expanded', 'false');
  }

  function initCallouts() {
    var callouts = document.querySelectorAll('.sydney-marathon-2026-collab__callout');

    if (!callouts.length) {
      return;
    }

    callouts.forEach(function (callout) {
      callout.addEventListener('click', function (event) {
        if (!isMobile()) {
          return;
        }

        event.stopPropagation();
        var isOpen = callout.classList.toggle('is-open');
        callout.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });

    document.addEventListener('click', function (event) {
      if (!isMobile()) {
        return;
      }

      callouts.forEach(function (callout) {
        if (callout.classList.contains('is-open') && !callout.contains(event.target)) {
          closeCallout(callout);
        }
      });
    });
  }

  function syncStickyStock(mainStock, stickyStock, stickyStockWrap) {
    if (!stickyStock) {
      return;
    }

    if (stickyStockWrap) {
      stickyStockWrap.hidden = false;
    }

    if (!mainStock) {
      return;
    }

    var progress =
      mainStock.style.getPropertyValue('--sm2026-collab-progress').trim() ||
      mainStock.dataset.progress ||
      '0';

    stickyStock.style.setProperty('--sm2026-collab-progress', progress);
    stickyStock.dataset.inventory = mainStock.dataset.inventory || '';
    stickyStock.dataset.progress = mainStock.dataset.progress || progress;

    var mainText = mainStock.querySelector('.sydney-marathon-2026-collab__stock-text');
    var stickyText = stickyStock.querySelector('.sydney-marathon-2026-collab__stock-text');

    if (mainText && stickyText) {
      stickyText.innerHTML = mainText.innerHTML;
    }
  }

  function syncStickyBuyButton(mainBuyBtn, stickyBuyBtn, stickyStockWrap) {
    if (!stickyBuyBtn) {
      return;
    }

    if (!mainBuyBtn) {
      stickyBuyBtn.hidden = true;
      return;
    }

    stickyBuyBtn.hidden = false;
    stickyBuyBtn.textContent = mainBuyBtn.textContent.trim();

    var isSoldOut = mainBuyBtn.classList.contains('is-sold-out');
    stickyBuyBtn.classList.toggle('is-sold-out', isSoldOut);

    if (isSoldOut) {
      stickyBuyBtn.setAttribute('disabled', 'disabled');
      stickyBuyBtn.setAttribute('aria-disabled', 'true');
    } else {
      stickyBuyBtn.removeAttribute('disabled');
      stickyBuyBtn.removeAttribute('aria-disabled');
    }
  }

  function getCartConfig(section) {
    var script = section.querySelector('.sm2026-collab-cart-config');
    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  function getGiftCartApi() {
    return window.opendotsGiftCart || null;
  }

  function buildMarathonGiftItems(gifts, quantity, mainVariantId) {
    return (gifts || [])
      .map(function (gift) {
        var variantId = Number(gift && gift.variantId);
        if (!Number.isFinite(variantId) || variantId <= 0) {
          return null;
        }

        return {
          id: variantId,
          quantity: quantity,
          properties: {
            _warranty_main_variant_id: String(mainVariantId),
            _benefit_linked: 'true',
            _benefit_handle: String((gift && gift.handle) || ''),
            _bundle_item_type: 'marathon_gift',
            _bundle_locked: 'true',
          },
        };
      })
      .filter(Boolean);
  }

  function setBuyButtonLoading(button, isLoading) {
    if (!button) {
      return;
    }

    button.classList.toggle('is-adding', isLoading);

    if (isLoading) {
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
      return;
    }

    if (!button.classList.contains('is-sold-out')) {
      button.removeAttribute('disabled');
      button.removeAttribute('aria-disabled');
    }
  }

  function openCartDrawer() {
    if (window.timber && window.timber.RightDrawer && typeof window.timber.RightDrawer.open === 'function') {
      window.timber.RightDrawer.open();
    }
  }

  function bindAddToCart(section) {
    var config = getCartConfig(section);
    if (!config || !config.mainVariantId || !Array.isArray(config.gifts) || !config.gifts.length) {
      return;
    }

    var buttons = [];
    section.querySelectorAll('[data-collab-add-to-cart]').forEach(function (button) {
      buttons.push(button);
    });

    var stickyBar = document.querySelector('[data-collab-sticky-bar]');
    if (stickyBar) {
      stickyBar.querySelectorAll('[data-collab-add-to-cart]').forEach(function (button) {
        if (buttons.indexOf(button) === -1) {
          buttons.push(button);
        }
      });
    }

    if (!buttons.length) {
      return;
    }

    var isSubmitting = false;

    function handleAddToCart(button) {
      if (isSubmitting || button.classList.contains('is-sold-out')) {
        return;
      }

      var giftCartApi = getGiftCartApi();
      if (!giftCartApi || typeof giftCartApi.addBundle !== 'function') {
        console.error('Marathon collab add to cart: gift cart API unavailable.');
        return;
      }

      var mainVariantId = Number(config.mainVariantId);
      var quantity = Math.max(1, Number(config.quantity) || 1);
      var giftItems = buildMarathonGiftItems(config.gifts, quantity, mainVariantId);

      if (!giftItems.length) {
        console.error('Marathon collab add to cart: gift variants are not configured.');
        return;
      }

      isSubmitting = true;
      setBuyButtonLoading(button, true);
      buttons.forEach(function (btn) {
        if (btn !== button) {
          setBuyButtonLoading(btn, true);
        }
      });

      var submitTask = function () {
        return giftCartApi.addBundle(
          {
            mainItem: { id: mainVariantId, quantity: quantity },
            giftItems: giftItems,
          },
          { skipLegacyGiftSync: true }
        );
      };

      var request = typeof giftCartApi.enqueue === 'function'
        ? giftCartApi.enqueue(submitTask)
        : submitTask();

      request
        .then(function () {
          openCartDrawer();
        })
        .catch(function (error) {
          console.error('Marathon collab add to cart failed:', error);
        })
        .finally(function () {
          isSubmitting = false;
          buttons.forEach(function (btn) {
            if (!btn.classList.contains('is-sold-out')) {
              setBuyButtonLoading(btn, false);
            }
          });
        });
    }

    buttons.forEach(function (button) {
      if (button.dataset.collabAddBound === 'true') {
        return;
      }

      button.dataset.collabAddBound = 'true';
      button.addEventListener('click', function () {
        handleAddToCart(button);
      });
    });
  }

  function getTrackingConfig(section) {
    var script = section.querySelector('.sm2026-collab-ga4-config');
    if (!script) {
      return null;
    }

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return null;
    }
  }

  var COLLAB_GA4_META_FALLBACKS = {
    S820SM: [
      'openrun-pro2-TCS-Sydney-Marathon-presented-by-ASICS-Co-Branded-Edition',
      'Sports',
      'S820',
      'Standard',
    ],
  };

  function getMappedProductMeta(itemId) {
    if (typeof product_handle_valueMap === 'undefined' || typeof product_handle_map === 'undefined') {
      return COLLAB_GA4_META_FALLBACKS[itemId] || null;
    }

    if (product_handle_map.has(itemId) && product_handle_valueMap[itemId]) {
      return product_handle_valueMap[itemId];
    }

    return COLLAB_GA4_META_FALLBACKS[itemId] || null;
  }

  function resolveGa4MetaValue(mappedValue, fallbackValue) {
    if (mappedValue !== undefined && mappedValue !== null && String(mappedValue).trim() !== '') {
      return mappedValue;
    }

    if (fallbackValue !== undefined && fallbackValue !== null && String(fallbackValue).trim() !== '') {
      return fallbackValue;
    }

    return '';
  }

  function buildGa4Item(config, listId, listName) {
    var mapped = getMappedProductMeta(config.itemId);
    var itemCategory3 = String(config.itemCategory3 || '').replace('Default Title', 'none');
    var item = {
      item_id: config.itemId,
      item_name: resolveGa4MetaValue(mapped && mapped[0], config.itemName || config.itemNameFallback),
      index: config.index,
      item_list_id: listId,
      item_list_name: listName,
      item_category: resolveGa4MetaValue(mapped && mapped[2], config.itemCategory),
      item_category2: resolveGa4MetaValue(mapped && mapped[3], config.itemCategory2 || 'Standard'),
      item_category3: itemCategory3,
      item_variant: resolveGa4MetaValue(mapped && mapped[1], config.itemVariant),
      item_brand: 'SHOKZ',
      price: Number(config.price) || 0,
      quantity: Number(config.quantity) || 1,
      currency: config.currency || 'AUD',
    };

    if (Number(config.discount) > 0) {
      item.discount = Number(config.discount);
    }

    return item;
  }

  function pushGa4Event(eventName, config, listId, listName, options) {
    if (!config || !config.itemId || typeof window.dataLayer === 'undefined') {
      return;
    }

    options = options || {};
    var item = buildGa4Item(config, listId, listName);
    var eventParameters = {
      currency: config.currency || 'AUD',
      item_list_id: listId,
      item_list_name: listName,
      items: [item],
    };

    if (eventName === 'add_to_cart') {
      eventParameters.value = item.price * item.quantity;
      eventParameters.button_name = options.buttonName || '';
    }

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: eventParameters,
    });
  }

  function initItemListImpression(section, config) {
    if (!('IntersectionObserver' in window)) {
      return;
    }

    var footer = section.querySelector('.sydney-marathon-2026-collab__main-footer');
    if (!footer) {
      return;
    }

    var tracked = false;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (tracked || !entry.isIntersecting) {
            return;
          }

          var rect = entry.boundingClientRect;
          var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
          var isBottomInViewport = rect.bottom > 0 && rect.bottom <= viewportHeight;

          if (!isBottomInViewport) {
            return;
          }

          tracked = true;
          pushGa4Event('view_item_list', config, 'marathon_exclusive', 'marathon_exclusive');
          observer.disconnect();
        });
      },
      { threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    );

    observer.observe(footer);
  }

  function bindAddToCartTracking(button, config, listId, listName) {
    if (!button || button.dataset.collabGa4Bound === 'true') {
      return;
    }

    button.dataset.collabGa4Bound = 'true';
    button.addEventListener('click', function () {
      if (button.classList.contains('is-sold-out')) {
        return;
      }

      pushGa4Event('add_to_cart', config, listId, listName, {
        buttonName: button.textContent.trim(),
      });
    });
  }

  function bindExploreMoreScroll() {
    document.querySelectorAll('[data-collab-explore-more]').forEach(function (button) {
      if (button.dataset.collabExploreBound === 'true') {
        return;
      }

      button.dataset.collabExploreBound = 'true';
      button.addEventListener('click', function () {
        var targetSelector = button.getAttribute('data-explore-target');
        if (!targetSelector || targetSelector.charAt(0) !== '#') {
          return;
        }

        var target = document.querySelector(targetSelector);
        if (!target) {
          return;
        }

        var siteHeader = document.querySelector('.site-header');
        var headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
        var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 60;

        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      });
    });
  }

  function initGa4Tracking() {
    var section = document.querySelector(SECTION_SELECTOR);
    if (!section || section.dataset.collabGa4Init === 'true') {
      return;
    }

    var config = getTrackingConfig(section);
    if (!config || !config.itemId) {
      return;
    }

    section.dataset.collabGa4Init = 'true';

    initItemListImpression(section, config);

    var mainBuyBtn = section.querySelector('.sydney-marathon-2026-collab__main-footer .sydney-marathon-2026-collab__buy-btn');
    bindAddToCartTracking(mainBuyBtn, config, 'marathon_exclusive', 'marathon_exclusive');

    var stickyBuyBtn = document.querySelector(
      '[data-collab-sticky-bar] .sydney-marathon-2026-collab__sticky-bar-buy-btn'
    );
    bindAddToCartTracking(stickyBuyBtn, config, 'bottom_bar', 'bottom_bar');
  }

  function bindExploreMoreScroll() {
    document.querySelectorAll('[data-collab-explore-more]').forEach(function (button) {
      if (button.dataset.collabExploreBound === 'true') {
        return;
      }

      button.dataset.collabExploreBound = 'true';
      button.addEventListener('click', function () {
        var targetSelector = button.getAttribute('data-explore-target');
        if (!targetSelector || targetSelector.charAt(0) !== '#') {
          return;
        }

        var target = document.querySelector(targetSelector);
        if (!target) {
          return;
        }

        var siteHeader = document.querySelector('.site-header');
        var headerHeight = siteHeader ? siteHeader.offsetHeight : 0;
        var targetPosition = target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 60;

        window.scrollTo({ top: targetPosition, behavior: 'smooth' });
      });
    });
  }

  function initStickyBar() {
    var stickyBar = document.querySelector('[data-collab-sticky-bar]');

    if (!stickyBar || stickyBar.dataset.collabStickyInit === 'true') {
      return;
    }

    stickyBar.dataset.collabStickyInit = 'true';

    if (stickyBar.parentElement !== document.body) {
      document.body.appendChild(stickyBar);
    }

    var sectionSelector = stickyBar.getAttribute('data-section-selector') || SECTION_SELECTOR;
    var section = document.querySelector(sectionSelector);

    if (!section) {
      return;
    }

    var mainBody = section.querySelector('.sydney-marathon-2026-collab__main-body');
    var mainStock = section.querySelector('.sydney-marathon-2026-collab__main-body .sydney-marathon-2026-collab__stock');
    var stickyStock = stickyBar.querySelector('.sydney-marathon-2026-collab__sticky-bar-stock');
    var stickyStockWrap = stickyBar.querySelector('.sydney-marathon-2026-collab__sticky-bar-stock-wrap');
    var mainBuyBtn = section.querySelector('.sydney-marathon-2026-collab__main-footer .sydney-marathon-2026-collab__buy-btn');
    var stickyBuyBtn = stickyBar.querySelector('.sydney-marathon-2026-collab__sticky-bar-buy-btn');
    var triggerEl = mainBody || section;
    var triggerBottom = 0;
    var scrollTicking = false;

    function updateStickyBarHeight() {
      document.documentElement.style.setProperty(
        '--sm2026-collab-sticky-bar-height',
        stickyBar.offsetHeight + 'px'
      );
    }

    function recalcTriggerBottom() {
      triggerBottom = triggerEl.getBoundingClientRect().bottom + window.scrollY;
    }

    function syncStickyBarContent() {
      syncStickyStock(mainStock, stickyStock, stickyStockWrap);
      syncStickyBuyButton(mainBuyBtn, stickyBuyBtn, stickyStockWrap);
    }

    function updateStickyBarVisibility() {
      var isPastTrigger = window.scrollY >= triggerBottom;

      stickyBar.classList.toggle('is-visible', isPastTrigger);
      stickyBar.hidden = !isPastTrigger;
      stickyBar.setAttribute('aria-hidden', isPastTrigger ? 'false' : 'true');
      document.body.classList.toggle('sydney-marathon-collab-sticky-active', isPastTrigger);

      if (isPastTrigger) {
        updateStickyBarHeight();
      }
    }

    function handleScroll() {
      if (scrollTicking) return;
      scrollTicking = true;
      window.requestAnimationFrame(function () {
        scrollTicking = false;
        updateStickyBarVisibility();
      });
    }

    function handleResize() {
      recalcTriggerBottom();
      syncStickyBarContent();
      updateStickyBarVisibility();
    }

    recalcTriggerBottom();
    syncStickyBarContent();
    updateStickyBarVisibility();

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize);
    window.addEventListener('load', handleResize, { once: true });
  }

  function init() {
    var section = document.querySelector(SECTION_SELECTOR);
    initCallouts();
    bindExploreMoreScroll();
    initGa4Tracking();
    initStickyBar();
    if (section) {
      bindAddToCart(section);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
